module.exports = __webpack_public_path__ + "layout_sprites@2x.f8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/layout_sprites@2x.png
// module id = ./src/_asset/sources/assets/images/layout_sprites@2x.png
// module chunks = main